const WORDS_PER_MINUTE = 200;

const stripHtml = (html: string): string => html.replaceAll(/<[^>]*>/g, '');

export const getReadingTime = (content: string): number => {
  try {
    const parsed = JSON.parse(content);
    if (parsed && Array.isArray(parsed.blocks)) {
      const text = parsed.blocks
        .map((block: { type: string; data: Record<string, unknown> }) => {
          switch (block.type) {
            case 'paragraph':
            case 'header':
            case 'quote':
              return stripHtml((block.data.text as string) ?? '');
            case 'list':
              return ((block.data.items as string[]) ?? []).map(stripHtml).join(' ');
            case 'warning':
              return [
                stripHtml((block.data.title as string) ?? ''),
                stripHtml((block.data.message as string) ?? ''),
              ].join(' ');
            case 'code':
              return (block.data.code as string) ?? '';
            default:
              return '';
          }
        })
        .join(' ');

      const wordCount = text.split(/\s+/).filter(Boolean).length;
      return Math.max(1, Math.ceil(wordCount / WORDS_PER_MINUTE));
    }
  } catch {
    // Legacy HTML content
  }

  const text = stripHtml(content);
  const wordCount = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(wordCount / WORDS_PER_MINUTE));
};
